import { graphql } from '@gql';

export const GET_MAINTENANCE_DATA = graphql(`
    query getMaintenanceInfo {
        maintenanceData {
            message
        }
    }
`);
